import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router'; // 'react-router' yerine 'react-router-dom' kullanıldı.
import { DATA } from '../../data/header-data';
import MobileHeader from './MobileHeader';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Dropdown = ({ items, isSubmenu = false }) => {
    const [openIndex, setOpenIndex] = useState(null);
    const dropdownRef = useRef(null);
    const { i18n } = useTranslation();
    const currentLang = i18n.language 

    const toggleDropdown = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenIndex(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <ul ref={dropdownRef} className={`flex ${!isSubmenu ? 'flex ' : 'flex flex-col absolute w-max top-8'} justify-between w-full bg-genesisBlue`}>
            {items.map((item, index) => (
                <li key={index} className="relative w-max font-semibold flex items-center">
                    <Link
                        to={item.link}
                        onClick={(e) => {
                            if (item.dropDown) e.preventDefault();
                            toggleDropdown(index);
                        }}
                         className={`block py-2 hover:text-customGold1 text-14 lg:text-16 px-1 lg:px-3 transition-all duration-300 group text-white`}
                    >
                        <div className='flex'>
                            {item.image && <img src={item.image} className='h-3 mr-1' />}
                            {item.title[currentLang]} {/* Dil desteği eklendi */}
                        </div>
                    </Link>
                    {item.dropDown && openIndex === index && (
                        <Dropdown items={item.dropDown} isSubmenu={true} />
                    )}
                </li>
            ))}
        </ul>
    );
};

const Header = () => {
    const location = useLocation();
    const [toggle, setToggle] = useState(false);
    const isHomePageOrCorporate = location.pathname === '/';
    const { i18n } = useTranslation();
    const currentLang = i18n.language || 'tr';

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className='sticky top-0 z-50'>
            {/* Üst Dil Seçme Çubuğu */}
            <div className='w-full grid grid-cols-11 bg-[#00215d] border-b-[#E6E6E6]'>
                  <div className={`${isHomePageOrCorporate ? 'col-start-2 col-span-9 ' : 'col-start-2 col-span-9 lg:col-start-2 lg:col-span-9'} z-50 h-[2.78rem] py-2 flex justify-between items-center`}>
                    <div>
                    <div className='hidden md:flex items-center  h-2 space-x-2 hover:opacity-80 duration-300'>
                            <div className='inline-block'>
                            <img src='/images/icons/mail.svg' className='h-2.5'/>
                            </div>
                            <a href='mailto:info@genesiscs.com.tr' className='text-white text-16'>info@genesiscs.com.tr</a>
                        </div>
                    </div>
                    <div className='flex space-x-4'>
                                                <img onClick={() => changeLanguage('tr')} src='/images/language-icons/tr.svg' className='h-5 hover:scale-105 duration-300 cursor-pointer' />
                        <img onClick={() => changeLanguage('en')} src='/images/language-icons/en.svg' className='h-5 hover:scale-105 duration-300 cursor-pointer' />
                        <img onClick={() => changeLanguage('de')} src='/images/language-icons/ge.svg' className='h-5 hover:scale-105 duration-300 cursor-pointer' />

                    </div>
                </div>
            </div>

            {/* Ana Menü */}
            <div className='w-full grid grid-cols-11 bg-genesisBlue '>
                <div className={`${isHomePageOrCorporate ? 'col-start-2 col-span-9 ' : 'col-start-2 col-span-9 lg:col-start-2 lg:col-span-9'}`}>
                    <div className='flex justify-between items-center w-full py-[1.35rem]'>
                        {/* Logo */}
                        <Link to={'/'} className='md:pl-[1.45rem]'>
                            <img src='/images/genesis-logo.svg' className='h-12' />
                        </Link>

                        {/* Masaüstü Menü */}
                        <div className='hidden md:flex items-center lg:pr-[6%]'>
                            <Dropdown items={DATA} />
                        </div>

                        {/* Mobil Menü Butonu */}
                        <div onClick={() => setToggle(!toggle)} className='w-7 h-full md:hidden flex items-center cursor-pointer overflow-hidden'>
                            <div className='h-7 relative cursor-pointer'>
                                <div className={`w-7 h-0.5 transition-all duration-300 bg-white absolute ${toggle ? 'top-3 rotate-45' : 'top-0'}`}></div>
                                <div className={`w-7 h-0.5 transition-all duration-300 absolute ${toggle ? 'top-3 translate-x-40 bg-black' : 'top-3 bg-white'}`}></div>
                                <div className={`w-7 h-0.5 transition-all duration-300 bg-white absolute ${toggle ? 'top-3 -rotate-45' : 'top-6'}`}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobil Menü */}
                <AnimatePresence>
                    {toggle && (
                        <motion.div
                            initial={{ x: '100%' }}
                            animate={{ x: 0 }}
                            exit={{ x: '100%' }}
                            transition={{ type: 'tween', duration: 0.5 }}
                            className="fixed h-[calc(100vh-8.5em)] bg-white top-[8.5rem] left-0 z-50 w-full overflow-hidden overflow-y-auto"
                        >
                            <MobileHeader toggle={toggle} setToggle={setToggle} />
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
};

export default Header;
